module.exports = __webpack_public_path__ + "img/JamesNg.ae31b173.png";